import { useTheme } from "@mui/material";
import * as React from "react";

interface IProps {
    width?: number | string;
    strokeWidth?: number | string;
}

export const MprcLine: React.FC<IProps> = (props) => {
    const { width = "100%", strokeWidth = 2 } = props;
    const theme = useTheme();
    return (
        <svg height="6" width={width}>
            <line x1="0" y1="0" x2={width} y2="0" style={{ stroke: theme.palette.muted.main, strokeWidth: strokeWidth }} />
        </svg>
    );
};
